// ============================
// File: src/pages/POCPage.jsx
// ============================
import React from "react";
import { CheckpointBoard } from "../features/poc";
import DemandPageHeader from "../components/DemandPageHeader";
import DemandSelector from "../components/DemandSelector";
import AdvanceStageBar from "../components/AdvanceStageBar";
import { useDemandId } from "../context/DemandContext";

// Removed: a "Next Actions" button row that called generateRequirements /
// prescreenSecurity / tabDecide / executeDemand straight from this page with
// hardcoded payloads (an APPROVE_WITH_CONDITIONS decision naming "Add audit log
// plan", targeting Jira) and showed neither confirmation nor result. It was
// harmless while those endpoints 404'd. They are real now, so a single click here
// would have recorded a TAB decision and created a ServiceNow project from the POC
// screen. Each of those actions belongs on its own stage page.

export default function POCPage() {
  const { demandId, setDemandId } = useDemandId();

  if (!demandId) {
    return (
      <div style={{ padding: 40, textAlign: "center", color: "var(--cares-text-label)" }}>
        No demand selected. Pick one from the Demand Dashboard.
      </div>
    );
  }

  return (
    <div>
      <DemandPageHeader
        title="Enhanced Discovery (POC)"
        description="30/60/90 day checkpoint tracking for proof of concept validation"
        breadcrumbPath="Enhanced Discovery (POC)"
      >
        <DemandSelector currentDemandId={demandId} stage="poc" onDemandChange={setDemandId} />
      </DemandPageHeader>
      <CheckpointBoard demandId={demandId} />
      {/* POC had no way to hand a demand on to AI Requirements — the board saved
          setup, notes and evidence but never changed current_stage, so the demand
          stopped here permanently. */}
      <div className="mx-auto max-w-7xl px-6 pb-6">
        <AdvanceStageBar demandId={demandId} />
      </div>
    </div>
  );
}
